import { useEffect, useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Square, Timer } from 'lucide-react';
import { useTimer, useStopTimer, elapsedLabel } from './api';

// Indikátor běžících stopek v topbaru — vidíš ho všude, zastavíš jedním klikem.
export default function TimerBar() {
  const { data: timer } = useTimer();
  const stop = useStopTimer();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!timer) return;
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, [timer]);

  if (!timer) return null;
  return (
    <div className="flex min-w-0 items-center gap-2 rounded-lg border border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950/30 pl-2.5 pr-1 h-9 text-sm">
      <Timer size={15} className="text-emerald-600 dark:text-emerald-400 shrink-0" />
      <Link to="/stanice" className="min-w-0 max-w-24 truncate text-emerald-800 sm:max-w-44 dark:text-emerald-300 hover:underline">
        {timer.phase.propItem.name}
      </Link>
      <span className="shrink-0 whitespace-nowrap tabular-nums text-emerald-700 dark:text-emerald-400">{elapsedLabel(timer.startedAt, now)}</span>
      <button
        onClick={() => stop.mutate(undefined)}
        disabled={stop.isPending}
        className="grid h-8 w-8 shrink-0 place-items-center rounded-md text-emerald-700 dark:text-emerald-300 hover:bg-emerald-100 dark:hover:bg-emerald-900/40"
        title="Zastavit a zapsat čas"
        aria-label="Zastavit stopky"
      >
        <Square size={13} fill="currentColor" />
      </button>
    </div>
  );
}
